<template>
  <!-- 新增运单跟踪-->
  <div class="container">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="clickReturnList"
      >返回列表</el-button>
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="getData"
      >刷新</el-button>
      <!-- <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存录入</el-button
      >-->
    </div>
    <div
      class="contentInner"
      :style="'height:' + tableHeigth + 'px'"
    >
      <!-- 左边 -->
      <div class="rightInner">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in TrackList"
            :key="index"
            :timestamp="item.title"
            placement="top"
            :color="item.color"
          >
            <el-card>
              <div class="card_class">
                <div class="line_cont">
                  <aside>{{ item.content }}</aside>
                  <div class="displayFlex">
                    <div v-if="item.expandFieldOne">
                      车牌号：{{ item.expandFieldOne || "" }}。
                    </div>
                    <div v-if="item.expandFieldTwo">
                      发出仓库：{{ item.expandFieldTwo || "" }}，
                    </div>
                    <div v-if="item.expandFieldThree">
                      目的地：{{ item.expandFieldThree || "" }}
                    </div>
                  </div>
                  <div class="trackImgsList">
                    <el-image
                      v-for="(itemA, idxA) in item.fileVoList"
                      :key="idxA"
                      class="trackImgs"
                      :src="itemA.fileUrl"
                      :preview-src-list="item.imgsList"
                    ></el-image>
                  </div>
                  <!-- <section>{{ item.createTime }}</section> -->
                  <section>{{ item.happenTime }}</section>
                </div>
                <el-switch
                  v-model="item.isShow"
                  @change="changeisShow(item)"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div
          class="nodata"
          v-if="TrackList.length == 0"
        >暂无运单轨迹</div>
      </div>
      <!-- 右边 -->
      <div class="leftInner">
        <div class="tit_top">
          <span>运单号: {{ waybillNumber || "--" }}</span>
        </div>
        <div class="tit_top">
          <span>外发承运商: {{ carrierName || "--" }}</span>
          <span>外发金额: {{ outgoingTotalFreight || "--" }}</span>
        </div>
        <div class="tit_top">
          <span>外发单号: {{ outgoingNumber || "--" }}</span>
          <span>承运商联系电话: {{ carrierPhone || "--" }}</span>
        </div>
        <el-tabs
          v-model="activeName"
          type="card"
          stretch
        >
          <el-tab-pane
            label="提货录入"
            name="提货录入"
          ></el-tab-pane>
          <el-tab-pane
            label="运输中"
            name="运输中"
          ></el-tab-pane>
          <el-tab-pane
            label="已签收"
            name="已签收"
          ></el-tab-pane>
          <!-- <el-tab-pane label="到车" name="已到车"></el-tab-pane>
          <el-tab-pane label="转运" name="已转运"></el-tab-pane>
          <el-tab-pane label="送货" name="已送货"></el-tab-pane>-->
        </el-tabs>
        <div
          class="infoDiv"
          v-if="activeName !='提货录入'"
        >
          <div class="formbox">
            <el-form
              label-width="130px"
              class="glo_formBox"
            >
              <el-form-item
                style="width: 100%"
                v-if="activeName == '运输中'"
                label="发生时间:"
                required
              >
                <el-date-picker
                  v-model="addReqs.happenTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="车牌号码:">
                <el-input
                  v-model="addReqs.expandFieldOne"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>-->
              <el-form-item
                v-if="
                  activeName == '已转运' ||
                  activeName == '已发车' ||
                  activeName == '已到车'
                "
                :label="activeName == '已到车' ? '到车仓库:' : '发出仓库:'"
              >
                <el-select
                  v-model="addReqs.expandFieldTwo"
                  placeholder="请输入/选择"
                  clearable
                  filterable
                  allow-create
                >
                  <el-option
                    v-for="(item, index) in CarrierDeptListList"
                    :key="index"
                    :label="item.deptName"
                    :value="item.carrierDeptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="目的地:"
                v-if="activeName == '已转运'"
              >
                <el-input
                  v-model="addReqs.expandFieldThree"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
              <div
                class="signClass"
                v-if="activeName == '已签收'"
              >
                <div
                  style="width: 100%"
                  class="glo_disflex"
                >
                  <div style="margin-right: 20px; margin-bottom: 18px">
                    <el-checkbox
                      style="height: 30px; line-height: 30px"
                      v-model="isReceiveUserSign"
                      label="isReceiveUserSign"
                      name="type"
                    >默认收货人为签收人</el-checkbox>
                  </div>
                  <el-form-item
                    label="签收人:"
                    prop
                    v-if="!isReceiveUserSign"
                  >
                    <el-input
                      v-model="baseInForm.signForName"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- <el-form-item label="收件人身份证号:">
                  <el-input
                    v-model="baseInForm.receiverIdcardNumber"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item> -->
                <el-form-item
                  label="签收时间:"
                  prop="signForTime"
                  style="width: 100%"
                >
                  <el-date-picker
                    v-model="baseInForm.signForTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  label="签收情况:"
                  prop="signForSituation"
                >
                  <el-select
                    v-model="baseInForm.signForSituation"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in signForSituationList"
                      :key="index"
                      :label="item.showName"
                      :value="item.statusVal"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <div style="width: 100%; display: flex">
                  <el-checkbox-group
                    class="checkBoxStyle"
                    v-model="isRnOrderSure"
                  >
                    <el-checkbox
                      label="isRnOrderSure"
                      name="type"
                    >回单收回确认</el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox-group
                    class="checkBoxStyle"
                    v-model="baseInForm.Sms"
                  >
                    <el-checkbox
                      label="isSenderSms"
                      name="sendFa"
                    >发送手机信息给发货人</el-checkbox>
                    <el-checkbox
                      label="isReceiverSms"
                      name="sendShou"
                    >发送手机信息给收货人</el-checkbox>
                  </el-checkbox-group>
                </div>

                <el-form-item
                  label="收回部门:"
                  prop="returnDeptId"
                  v-if="isRnOrderSure.length > 0"
                >
                  <el-select
                    filterable
                    clearable
                    v-model="baseInForm.returnDeptId"
                    placeholder="请选择"
                    @focus="getObjectUserDownList('dept')"
                  >
                    <el-option
                      v-for="(item, index) in depList"
                      :key="index"
                      :label="item.name"
                      :value="item.documentId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="收回人:"
                  prop="returnUserId	"
                  v-if="isRnOrderSure.length > 0"
                >
                  <el-select
                    filterable
                    clearable
                    v-model="baseInForm.returnUserId"
                    placeholder="请选择"
                    @focus="getObjectUserDownList('employee')"
                  >
                    <el-option
                      v-for="(item, index) in EmployeeList"
                      :key="index"
                      :label="item.name"
                      :value="item.documentId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <el-form-item
                class="textArea"
                style="width: 100%"
                label="跟踪信息:"
                required
              >
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="addReqs.content"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="activeName != '已签收'"
                class="textArea"
                style="width: 100%"
                label="显示到运单轨迹:"
                required
              >
                <el-switch
                  v-model="addReqs.isShow"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>
            </el-form>
            <div
              class="infoDiv"
              v-if="activeName != '已签收'"
            >
              <div style="margin-bottom: 10px">图片:</div>
              <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="9"
              ></uploadimgs>
            </div>

            <div
              class="uploadBox"
              v-if="activeName == '已签收'"
            >
              <div class="uploadItem">
                <div class="uploadLaber">签收图片</div>
                <uploadimgs
                  @input="changeFileList"
                  :fileNameLists="fileNameLists"
                  :limit="15"
                ></uploadimgs>
              </div>

              <div
                class="uploadItem"
                v-if="isRnOrderSure.length > 0"
              >
                <div class="uploadLaber">回单图片</div>
                <uploadimgs
                  @input="changeFileList2"
                  :fileNameLists="fileNameLists2"
                  :limit="6"
                ></uploadimgs>
              </div>
            </div>
          </div>
        </div>
        <div
          class="infoDiv"
          v-if="activeName =='提货录入'"
        >
          <div class="formbox">
            <el-form
              label-width="130px"
              class="glo_formBox"
            >
              <el-form-item
                style="width: 100%"
                label="提货时间:"
                required
              >
                <el-date-picker
                  v-model="addReqs1.takeTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="提货员">
                <el-select
                  v-model="addReqs1.takeUserId"
                  placeholder="请选择"
                  clearable
                  remote
                  filterable
                  :remote-method="
              (e) => {
                remoteMethod(e, 'employee', 'employeeList');
              }
            "
                  @focus="
              (e) => {
                focusMethod('employee', 'employeeList');
              }
            "
                  @clear="remoteMethod('', 'employee', 'employeeList')"
                >
                  <el-option
                    v-for="(item, index) in employeeList"
                    :key="index"
                    :label="item.name"
                    :value="item.documentId"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                class="textArea"
                style="width: 100%"
                label="备注信息:"
              >
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="addReqs1.remarks"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="uploadBox">
              <div class="uploadItem">
                <div class="uploadLaber">提货图片</div>
                <uploadimgs
                  @input="changeFileList"
                  :fileNameLists="fileNameLists"
                  :limit="9"
                ></uploadimgs>
              </div>
            </div>
          </div>
        </div>
        <el-button
          style="margin: 30px"
          class="glo_bgcMainColor"
          @click="submit"
        >保存录入</el-button>
        <el-button
          style="margin: 30px"
          v-if="activeName == '已签收'"
          @click="cancelReceipt"
        >取消签收</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import uploadimgs from '@/components/upLoadImgs.vue'
export default {
  inject: ['reload'],
  components: { uploadimgs },
  data() {
    return {
      isReceiveUserSign: true,
      signForSituationList: [],
      isRnOrderSure: [],

      tableHeigth: '75vh', //  表格高度
      activeName: '提货录入',
      carrierName: '',
      CarrierDeptListList: [], //网点
      fileNameLists: [], //上传组件的
      fileNameLists2: [],
      addReqs: {
        documentStatus: 'bill_tms_waybill_split_v3:document_status',
        content: '',
        documentNumber: '',
        expandFieldOne: '',
        expandFieldThree: '',
        expandFieldTwo: '',
        fileIds: '',
        title: '',
        isShow: true,
        happenTime: '',
      },
      baseInForm: {
        // 签收
        isReceiverSms: '',
        Sms: [],
        isSenderSms: '0',
        isRnOrderSure: '0',
        remarks: '',
        returnDeptId: '',
        returnUserId: '',
        rnOrderFileIds: [],
        signForFileIds: [],
        signForName: '',
        signForSituation: '',
        waybillNumbers: '',
        receiverIdcardNumber: '',
        agentIdcardNumber: '',
        agentPhone: '',
        signForTime: '',
      },
      addReqs1: {
        commandId: '',
        remarks: '',
        takeTime: '',
        takeUserId: '',
        waybillSplitId: '',
        files: [],
      },
      employeeList: [],
      TrackList: [],
      orderNumber: '',
      waybillNumber: '',
      outgoingNumber: '',
      carrierPhone: '',
      waybillSplitId: '',
      outgoingTotalFreight: '',
      depList: [],
      EmployeeList: [],
    }
  },
  watch: {},
  created() {},
  mounted() {
    // 根据对象类型获取结算对象的下拉列表
    // this.getObjectUserDownList("employee"); //获取员工列表
    // this.getObjectUserDownList("dept"); //获取部门列表

    console.log('this.addReqs.happenTime', this.addReqs.happenTime)
    // 获取签收情况下拉列表
    this.$TOOLS
      .getStatusValList('bill_tms_waybill_sign_for_v3.sign_for_situation')
      .then((res) => {
        this.signForSituationList = res || []
        if (this.signForSituationList.length > 0) {
          //默认正常签收
          this.baseInForm.signForSituation = 'zheng_chang:sign_for_situation'
        }
      })
  },
  activated() {
    let pageType = this.$route.query.pageType || '' //isTabs==tab切换的页面,不刷新页面
    let isreloads = this.$route.query.isreload //关闭页面的标记,关闭tab,不刷新页面
    if (pageType == 'isTabs' || isreloads == 'isreload') {
      return false
    } else {
      this.init()
    }
  },
  destroyed() {},
  methods: {
    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod('', key, keys)
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || []
          this[keys] = arrs
        })
    },
    changeisShow({ isShow, trackTransportId }) {
      this.$API
        .updateTrackTransportShow({
          isShow: isShow ? 1 : 0,
          trackTransportIds: [trackTransportId],
        })
        .then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.getData()
        })
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key, name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          name: name || '',
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || []
          if (key == 'employee') {
            this.EmployeeList = arrs
          }
          if (key == 'dept') {
            this.depList = arrs
          }
          if (key == 'storage') {
            this.storageList = arrs
          }
        })
    },
    // 点击左边
    clickItems(item) {},
    init() {
      this.fileNameLists = []
      this.fileNameLists2 = []
      this.addReqs = {
        documentStatus: 'bill_tms_waybill_split_v3:document_status',
        content: '',
        documentNumber: '',
        expandFieldOne: '',
        expandFieldThree: '',
        expandFieldTwo: '',
        fileIds: '',
        title: '',
        isShow: true,
        happenTime: '',
      }

      this.addReqs.happenTime = this.$TOOLS.getCurrentTime()
      this.baseInForm.signForTime = this.$TOOLS.getCurrentTime()
      this.addReqs1 = {
        commandId: '',
        remarks: '',
        takeTime: '',
        takeUserId: '',
        waybillSplitId: '',
        files: [],
      }
      this.addReqs1.takeTime = this.$TOOLS.getCurrentTime()
      this.fetTableHeight()
      this.getData()
      // let { outboundCarrierId, outboundCarrierName, number } =
      //   this.$route.query || {};
      // this.addReqs.documentNumber = number || "";
      // this.outboundCarrierName = outboundCarrierName || "";
      // if (outboundCarrierId) {
      //   this.$COMAPI.CarrierDeptList(outboundCarrierId).then((res) => {
      //     this.CarrierDeptListList = res || [];
      //   });
      // }
    },
    getData() {
      let datas1 = this.$route.query.datas || ''
      if (datas1) {
        let datas = JSON.parse(datas1)
        console.log(datas)
        this.waybillNumber = datas.waybillNumber || ''
        this.carrierName = datas.carrierName || ''
        this.outgoingNumber = datas.outgoingNumber || ''
        this.carrierPhone = datas.carrierPhone || ''
        this.orderNumber = datas.number || ''
        this.waybillSplitId = datas.waybillSplitId || ''
        this.outgoingTotalFreight = datas.outgoingTotalFreight || ''
        this.addReqs.documentNumber = this.orderNumber
        this.addReqs1.commandId = datas.commandId || ''
        this.addReqs1.waybillSplitId = datas.waybillSplitId || ''
        this.remoteMethod(datas.takeUserName || '', 'employee', 'employeeList')
        this.addReqs1.takeUserId = datas.takeUserId || ''
        if (this.orderNumber) {
          this.$API
            .getTrackTransportList({
              documentNumber: this.orderNumber,
              documentStatus: 'bill_tms_waybill_split_v3:document_status',
            })
            .then((res) => {
              let arrs = res.data.result || []
              // .reverse()
              let TrackList = arrs //翻转数组
              TrackList.forEach((item, index) => {
                item.isShow = item.isShow == 1 ? true : false
                item.color = ''
                if (index == 0) {
                  item.color = '#0bbd87'
                }
                item.imgsList = []
                if (item.fileVoList && item.fileVoList.length > 0) {
                  item.fileVoList.forEach((itemA) => {
                    item.imgsList.push(itemA.fileUrl)
                  })
                }
              })

              this.TrackList = TrackList
            })
        }
      }
    },

    // 签收按钮
    saveBtns() {
      let pdata = JSON.parse(JSON.stringify(this.baseInForm))
      console.log(pdata)
      let isSenderSms = '0'
      let isReceiverSms = '0'
      let waybillNumbers = [this.waybillNumber]
      //发信息给收发货人 isHasTaskNoCompleteShow
      pdata.Sms.forEach((item) => {
        if (item == 'isSenderSms') {
          isSenderSms = '1'
        }
        if (item == 'isReceiverSms') {
          isReceiverSms = '1'
        }
      })

      // 处理图片
      let signForFileIds = []
      let rnOrderFileIds = []
      this.fileNameLists.forEach((item) => {
        // 签收图片
        signForFileIds.push(item.name)
      })
      this.fileNameLists2.forEach((item) => {
        // 回单图片
        rnOrderFileIds.push(item.name)
      })

      let params = {
        isReceiverSms: isReceiverSms || '0',
        isRnOrderSure: this.isRnOrderSure.length > 0 ? '1' : '0',
        isReceiveUserSign: this.isReceiveUserSign ? '1' : '0', //默认收货人
        isSenderSms: isSenderSms || '0',
        remarks: this.addReqs.content || '',
        returnDeptId: pdata.returnDeptId || '',
        returnUserId: pdata.returnUserId || '',
        rnOrderFileIds: rnOrderFileIds || [],
        signForFileIds: signForFileIds || [],
        signForName: pdata.signForName || '',
        signForSituation: pdata.signForSituation || '',
        agentIdcardNumber: pdata.agentIdcardNumber || '',
        agentPhone: pdata.agentPhone || '',
        receiverIdcardNumber: pdata.receiverIdcardNumber || '',
        signForTime: pdata.signForTime || '',
        waybillNumbers: waybillNumbers || [],
      }
      this.saveSignforWaybill(params)
    },
    // 确认签收接口
    saveSignforWaybill(params) {
      this.$API.wtl_signforWaybill(params).then((res) => {
        this.$message.success(res.data.message || '签收成功')

        this.tableData = []
        this.isRnOrderSure = []
        this.fileNameLists = []
        this.fileNameLists2 = []
        this.baseInForm = {
          isReceiverSms: '',
          Sms: [],
          isSenderSms: '0',
          isRnOrderSure: '0',
          remarks: '',
          returnDeptId: '',
          returnUserId: '',
          rnOrderFileIds: [],
          signForFileIds: [],
          signForName: '',
          signForSituation: '',
          waybillNumbers: '',
        }
        this.init()
      })
    },
    submit() {
      if (this.activeName == '提货录入') {
        this.addReqs1.files = this.fileNameLists.map((item) => {
          return {
            fileId: item.name,
            fileName: item.name,
            operationType: 'ADD',
          }
        })
        this.$API.waybillpickupEntry(this.addReqs1).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message || '操作成功')
            this.init()
          }
        })
      } else {
        let fids = []
        this.fileNameLists.forEach((item) => {
          fids.push(item.name)
        })
        this.addReqs.fileIds = fids
        this.addReqs.title = this.activeName
        let param = JSON.parse(JSON.stringify(this.addReqs))
        param.isShow = param.isShow ? 1 : 0
        if (this.activeName == '已签收') {
          this.saveBtns()
        } else {
          if (this.activeName == '运输中' && !this.addReqs.happenTime) {
            this.$message.error('请选择发生时间')
            return false
          }
          this.$API.addTrackTransport(param).then((res) => {
            if (res.data.status === 'success') {
              this.$message.success(res.data.message || '操作成功')
              this.init()
            }
          })
        }
      }
    },
    clickReturnList() {
      this.$TOOLS.closePage()
      this.$router.push({
        path: '/WaybillManage/TrackingWaybill',
        query: {
          isreload: 'isreload',
        },
      })
    },
    cancelReceipt() {
      this.$confirm('是否取消签收？请谨慎操作', '提示：')
        .then(() => {
          this.$API
            .cancelSignforWaybill({
              waybillSplitIds: [this.waybillSplitId],
            })
            .then((res) => {
              this.$message.success(res.data.message || '操作成功')
              this.init()
            })
        })
        .catch(() => {})
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array
    },
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight //页面高度
      let queryHeigth = 40 + 10 //10==margin-top: 10  查询框高度
      let pagsHeigth = 40 //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + pagsHeigth + 60 //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || '' //
      this.$nextTick(() => {
        this.tableHeigth = tabHeight
      })
    },
  },
}
</script>
<style scoped lang="less">
.lookImgs {
  color: mediumblue;
  margin: 6px 0;
}
.trackImgsList {
  display: flex;
  flex-wrap: wrap;

  .trackImgs {
    width: 60px;
    height: 60px;
    margin: 10px;
  }
}
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin: 0 30px;
  height: 50px;
}

.contentInner {
  width: 100%;
  display: flex;

  .rightInner {
    flex: 1;
    margin-right: 16px;
    cursor: pointer;
    overflow-y: auto;
    border: 1px solid #ddd;
    padding: 10px;
  }

  .leftInner {
    flex: 1;
    /deep/ .el-tabs__item {
      height: 36px;
      line-height: 36px;
      background-color: #f4f4f4;
    }

    /deep/ .el-tabs__content {
      padding: 16px;
    }

    /deep/ .el-descriptions {
      margin-bottom: 10px;
    }
  }
}
/deep/.el-timeline-item__timestamp {
  font-size: 16px;
  color: #333;
}
.line_cont {
  color: #888;
}
.tit_top {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
  span {
    flex: 1;
  }
}
// 查询条件边框线
.infoDiv {
  margin-bottom: 20px;

  .formbox {
    padding: 0 30px;
  }
}
.textArea {
  height: 100%;
}

.displayFlex {
  display: flex;
}

.nodata {
  width: 100%;
  text-align: center;
  margin-top: 40vh;
  color: #999;
}
.card_class {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.formbox {
  padding: 10px 30px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 33px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.signClass {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}
</style>
